import api from '@/api';
import { notification } from 'antd';

export const getAuthCodeAndRedirect = async (
  callbackUrl: string,
  target = '_self',
  options?: { destinationUrl: string },
) => {
  try {
    const destinationUrl =
      options?.destinationUrl || process.env.REACT_APP_GP_URL;

    const response = (await api.post('/authorization/auth/code', {
      destinationUrl,
    })) as { code?: string };

    if (response?.code) {
      const search = new URLSearchParams({
        code: response.code,
        callbackUrl,
      });

      window.open(destinationUrl + `?${search}`, target);
    }
  } catch {
    notification.error({
      message: 'Não foi possível gerar o código de redirecionamento',
    });
  }
};
